<template>
  <div style="background: #fff; height: 100%">
    <el-container>
      <el-header>
        <div class="handlePanel">
          <!-- <el-button
            type="primary"
            v-if="btnAuthorize.modifyBtn.btnEnable"
            @click="changeAllMsgState"
            icon="el-icon-setting"
          >置为已读</el-button> -->
          <el-button
            type="primary"
            v-if="btnAuthorize.delBtn.btnEnable"
            @click="clearAllMsg"
            icon="el-icon-setting"
            >删除消息</el-button
          >
        </div>
      </el-header>
      <el-main ref="main">
        <el-table
          class="ownerTable"
          :data="tableData"
          height="100%"
          size="mini"
          @selection-change="handleSelectionChange"
          border
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            v-for="(item, index) in formTitles"
            :key="index"
            :prop="item.class"
            :label="item.labelName"
            :sortable="item.sortable"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="150">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.actName == 'item_new'"
                @click="NewsDetail(scope.row)"
                type="text"
                size="small"
                >启动立项</el-button
              >
              <el-button
                v-else
                @click="NewsDetail(scope.row)"
                type="text"
                size="small"
                >查看</el-button
              >
              <!-- <el-button @click="changeState(scope.row)" type="text" size="small">置为已读</el-button> -->
            </template>
            <!-- <template slot-scope="scope">
              <span
                :style="scope.row.isRead == 0 ? 'color:#079DBD;font-size:12px;cursor:pointer;' : 'color:#333333;font-size:12px;'"
                @click="changeMsgState(scope.$index, scope.row)"
              >{{scope.row.isRead == 0 ? '置为已读' : '已读'}}</span>
            </template>-->
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <div style="display: flex; justify-content: space-between">
          <span
            style="
              color: #666666;
              font-size: 14px;
              line-height: 32px;
              margin-top: 16px;
            "
            >显示{{
              totalCount > 0
                ? (currentPage - 1) * pageSize +
                  1 +
                  "-" +
                  (currentPage * pageSize > totalCount
                    ? totalCount
                    : currentPage * pageSize)
                : "0"
            }}，共{{ totalCount }}条记录</span
          >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import {
  getLatestMessageList,
  readMsg,
  deleteDocumentService,
  readAllMsg,
  deleteBatchService,
} from "../../services/sysSettingService";
import Constants from "@/utils/consts.js";
import {
  getCurrentApproveListService, //查询当前审批流
} from "@/services/approveServices";

import { getRouteIdByType } from "@/page/approveComponents/approve";

export default {
  name: "latestNews",
  props: {
    menuCode: {
      type: String,
    },
  },

  data() {
    return {
      formInline: {
        user: "",
      },
      formTitles: [
        // { class: "id", labelName: "序号", sortable: false },
        { class: "title", labelName: "标题", sortable: false },
        // { class: "actName", labelName: "内容", sortable: false },
        { class: "createTime", labelName: "接收时间", sortable: false },
      ],
      tableData: [],
      selectItems: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      // settingBtnEnable: false,
      showHouseBind: false,
      showHouseBindTitle: "",
      showHouseRoomData: {},
      btnAuthorize: {
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false },
      },
    };
  },
  mounted() {},
  methods: {
    onActive(menuCode) {
      this.currentPage = 1;
      this.getMsgList();
      this.$getRoleBtns(menuCode, this.btnAuthorize);
    },
    getMsgList() {
      let param = {
        // userId: sessionStorage.getItem("userCode"),
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
      };

      getLatestMessageList(param)
        .then((res) => {
          if (res.code == 10000000) {
            // for (let index = 0; index < res.data.list.length; index++) {
            //   var element = res.data.list[index];
            //   if (element.messageBehavior == "700001")
            //     element.messageBehaviorStr = "绑定房产";
            //   let obj = JSON.parse(element.sendMessage);
            //   let msg =
            //     "业主" +
            //     obj.ownerName +
            //     "(" +
            //     obj.phone +
            //     ")" +
            //     "申请绑定" +
            //     obj.showName +
            //     ",请尽快处理";
            //   element.originMessage = element.sendMessage;
            //   element.sendMessage = msg;
            //   console.log(obj);
            // }
            this.totalCount = res.total;
            this.tableData = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((err) => {});
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getMsgList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getMsgList();
    },
    //更改选择项
    handleSelectionChange(val) {
      this.selectItems = val;
    },
    changeMsgState(index, row) {
      if (row.isRead != 0) {
        return;
      }
      let param = { messageNo: String(row.messageNo) };
      readMsg(param)
        .then((res) => {
          // this.$alert(res.msg, "提示", {
          //   confirmButtonText: "确定"
          // });
          this.getMsgList();
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    },
    //跳转详情
    NewsDetail(row) {
      let memberData = {};
      memberData.editFlag = false; //查看标志为1
      memberData.id = row.resourceId; //选中行
      memberData.addFlag = 0; //新增标志为1
      memberData.approveType = row.businessType;
      memberData.approveFlag = "commonMessage";
      // TODO: 根据businessType去设定后续操作。
      if (row.businessType == "GENERAL_CONTRACT") {
        this.bus.$emit("navMenuChange", {
          routeId: "mineReVisitList", //查看总包合同
          routeParam: memberData,
        });
      } else if (row.businessType == "PROJECT") {
        if (row.actName == "item_new") {
          this.bus.$emit("navMenuChange", {
            routeId: "find-setting", //新建项目
            routeParam: memberData,
          });
        } else {
          this.bus.$emit("navMenuChange", {
            routeId: "houseDeliveMgr", //查看项目
            routeParam: memberData,
          });
        }
      } else if (row.businessType == "SUB_CONTRACT") {
        this.bus.$emit("navMenuChange", {
          routeId: "totalApproveList", //查看劳务合同
          routeParam: memberData,
        });
      } else if (row.businessType == "DECLARATION") {
        this.bus.$emit("navMenuChange", {
          routeId: "meetingBillDetailView", //提报单
          routeParam: memberData,
        });
      } else if (row.businessType == "conference_declare"||row.businessType == "conference_feedback") {
        this.bus.$emit("navMenuChange", {
          routeId: "generalMeetingDetail", //综合会议
          routeParam: memberData,
        });
      } else if (row.businessType == "conference_other") {
        this.bus.$emit("navMenuChange", {
          routeId: "otherMeetingDetail", //其它会议
          routeParam: memberData,
        });
      } else if (row.businessType == "PROJECT_FRONT") {
        this.bus.$emit("navMenuChange", {
          routeId: "beforInfoDetails", //事前
          routeParam: memberData,
        });
      } else if (row.businessType == "PROJECT_MIDDLE") {
        this.bus.$emit("navMenuChange", {
          routeId: "inTheInfoDetails", //成本事中
          routeParam: memberData,
        });
      } else if (row.businessType == "INPUT_BILL_APPROVE") {
        this.bus.$emit("navMenuChange", {
          routeId: "approveDetails", //进项发票报销详情
          routeParam: memberData,
        });
      } else if (row.businessType == "OUTPUT_BILL_APPROVE") {
        this.bus.$emit("navMenuChange", {
          routeId: "salesInvoiceDetail", //销项发票报销申请详情
          routeParam: memberData,
        });
      } else if (row.businessType == "EARNING_COST") {
        this.bus.$emit("navMenuChange", {
          routeId: "incomingConstDetail", //收入成本
          routeParam: memberData,
        });
      } else if (row.businessType == "SUPPLIER") {
        this.bus.$emit("navMenuChange", {
          routeId: "supplierBApprove", //供应商
          routeParam: memberData,
        });
        // this.getApproveList(memberData);
      } else if (row.businessType == "supplier_score") {
        this.bus.$emit("navMenuChange", {
          routeId: "evaluateSupplierList", //供应商评价
          routeParam: memberData,
        });
        // this.getApproveList(memberData);
      }else if (row.businessType == "OFFICIAL_DOCUMENT_EXTERNAL") {
        this.bus.$emit("navMenuChange", {
          routeId: "incomingManageDetails", //公文-外部
          routeParam: memberData,
        });
        // this.getApproveList(memberData);
      } else if (row.businessType == "OFFICIAL_DOCUMENT_INTERNAL") {
        let routeId = "generalOfficeDetails";
        let type = 1;
        switch (row.resourcePathType) {
          case "processing_details": //收文查阅详情
            routeId = "processingDetails";
            break;
          case "common_check_details": //收文查阅详情
            routeId = "processingDetails";
            type = 2;
            break;
          case "general_office_details": //综合办发文
            routeId = "generalOfficeDetails";
            break;
          // case "general_office_details": //我的发文(其他)
          //   routeId = "generalOfficeDetails";
          //   break;
          case "document_manage_details": //我的发文(综合办)
            routeId = "documentManageDetails";
            break;
          default:
            // this.Contractform.tabIndex = "0";
            break;
        }
        memberData.type = type;
        this.bus.$emit("navMenuChange", {
          routeId: routeId, //公文
          routeParam: memberData,
        });
      } else if (row.businessType == "SPORADIC_PROJECT") {
        this.bus.$emit("navMenuChange", {
          routeId: "sporadicDetail", //零星工程
          routeParam: memberData,
        });
        // this.getApproveList(memberData);
      }else {
        this.$alert("返回的跳转类型错误", "提示", {
          confirmButtonText: "确定",
        });
      }
    },
    //查询当前审批流
    getApproveList(memberData) {
      let params = {
        id: memberData.id,
      };
      // param.itemId = this.supplierId; //供应商id
      params.type = "SUPPLIER"; //类型：供应商
      getCurrentApproveListService(params)
        .then((res) => {
          if (res.code == 10000000) {
            memberData.approveFlag = "currentApprove_commonMessage"; //审核标志为1
            // memberData.path = "order-list";
            this.bus.$emit("navMenuChange", {
              routeId: "supplierBApprove",
              routeParam: memberData,
            });
          } else {
            this.bus.$emit("navMenuChange", {
              routeId: "supplierBApprove", //供应商
              routeParam: memberData,
            });
          }
        })
        .catch((error) => {
          this.bus.$emit("navMenuChange", {
            routeId: "supplierBApprove", //供应商
            routeParam: memberData,
          });
        });
    },
    //置为已读按钮
    changeAllMsgState() {
      //点击置为已读按钮
      if (this.selectItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let param = {
        userId: sessionStorage.getItem("userCode"),
        messageBehaviors: "700001",
      };
      readAllMsg(param)
        .then((res) => {
          this.$alert(res.msg, "提示", {
            confirmButtonText: "确定",
          });
          this.getMsgList();
        })
        .catch((error) => {
          this.$message.error("网络请求失败");
        });
    },
    //置为已读
    changeState() {
      //do something
    },
    //清空消息中心 20230312
    clearAllMsg() {
      //点击删除按钮并确认删除
      if (this.selectItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示", {
          confirmButtonText: "确定",
        });
        return;
      }

      this.$confirm("确定要删除消息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        let ids = [];
        for (let index = 0; index < this.selectItems.length; index++) {
          const element = this.selectItems[index];
          ids.push(element.id);
        }
        let groupIdSet = ids.join(",");
        deleteBatchService({
          ids: groupIdSet,
        })
          .then((res) => {
            if (res.code == Constants.Code_OK) {
              this.$alert(Constants.Ok_Msg, "提示");
              this.getMsgList();
            } else {
              this.$alert(res.msg, "提示");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    closeDialogAction() {
      this.showHouseBind = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.operateView {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
/deep/.el-table__header {
  background: red !important;
}
</style>